class ResetPasswordDto {
  id!: string;

  password!: string;
}

export default ResetPasswordDto;
